export default "__VITE_PUBLIC_ASSET__e31fe5dc__"